"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var ObjectForm_1 = __importStar(require("../ObjectForm"));
var hooks_1 = require("../../modules/sections/hooks");
var SectionColorCircle_1 = __importDefault(require("./SectionColorCircle"));
var HEX_PATTERN = /^[A-Fa-f0-9]{6}$/;
var SectionForm = (0, react_1.memo)(function (props) {
    var objectForm = (0, ObjectForm_1.useObjectForm)(props);
    var currentColor = antd_1.Form.useWatch(["color"], objectForm.form);
    var sections = (0, hooks_1.useSections)().items;
    return react_1.default.createElement(ObjectForm_1.default, __assign({ objectForm: objectForm }, props),
        react_1.default.createElement(antd_1.Form.Item, { name: "id", label: "ID", rules: ObjectForm_1.RULES_REQUIRED_BASIC },
            react_1.default.createElement(antd_1.Input, { disabled: objectForm.editMode })),
        react_1.default.createElement(antd_1.Form.Item, { name: "title", label: "Title", rules: ObjectForm_1.RULES_REQUIRED_BASIC },
            react_1.default.createElement(antd_1.Input, null)),
        react_1.default.createElement(antd_1.Form.Item, { name: "color", label: "Colour", rules: __spreadArray(__spreadArray([], ObjectForm_1.RULES_REQUIRED_BASIC, true), [{ pattern: HEX_PATTERN }], false) },
            react_1.default.createElement(antd_1.Input, { addonBefore: react_1.default.createElement("div", { style: { display: "flex", gap: 8, alignItems: "center" } },
                    react_1.default.createElement(SectionColorCircle_1.default, { hex: HEX_PATTERN.test(currentColor) ? currentColor : "FAFAFA" }),
                    react_1.default.createElement("span", null, "#")) })),
        react_1.default.createElement(antd_1.Form.Item, { name: "rank", label: "Rank", rules: ObjectForm_1.RULES_REQUIRED_BASIC, initialValue: objectForm.editMode ? undefined : sections.length },
            react_1.default.createElement(antd_1.InputNumber, { min: 0 })));
});
exports.default = SectionForm;
